import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import { Table } from "antd";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";

const moduleNames = ["Child Related Expenses"];

export default function ChildRelatedExpenses() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Child Related Expenses");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  console.log("Attributes Data:", attributes);
  console.log("Disaster Attributes", disasterAttribute);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const tableDataObj = {
    "Support Calculations": tableData.supportCalculationsData,
    "Child Related Expenses": tableData.childRelatedExpensesData,
  };

  const { showModal, updateModal, viewModal, handelCloseModal } =
    useModalHandlers(
      attributes,
      setModalTitle,
      setModuleName,
      setIsModalVisible,
      setFormData,
      setAttributesData
    );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };

  return (
    <div style={{ position: "relative" }}>
      <div className="child-title-container">
        <h2 className="child-title">Child-Related Expenses</h2>
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />

          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  if (formData && Object.keys(formData).length > 0) {
                    await createAttributes();
                  }
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}

      <NewLoader isLoading={loading} />
    </div>
  );
}
